/* Atelier theme — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetWidth > 0 || n.offsetHeight > 0 || n === document.activeElement; });
  }
  function toast(message) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }
  function restoreFocus(id) {
    if (!id) return;
    var el = document.getElementById(id);
    if (el) el.focus({ preventScroll: true });
  }

  /* ---------- Drawers (mobile menu + cart) ---------- */
  var activeDrawer = null;
  var lastTrigger = null;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, true);
    activeDrawer = drawer;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    document.body.classList.add('has-drawer-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    setTimeout(function () { panel && panel.focus(); }, 60);
  }
  function closeDrawer(drawer, silent) {
    drawer = drawer || activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('has-drawer-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    activeDrawer = null;
    if (!silent && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var menuBtn = e.target.closest('[data-menu-open]');
    if (menuBtn) { e.preventDefault(); openDrawer(document.getElementById('MenuDrawer'), menuBtn); return; }

    var cartBtn = e.target.closest('[data-cart-drawer-open]');
    if (cartBtn && $('[data-cart-drawer]')) { e.preventDefault(); openDrawer($('[data-cart-drawer]'), cartBtn); return; }

    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(e.target.closest('.drawer')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) { closeDrawer(); return; }
      var openFacets = $('[data-facets].is-open');
      if (openFacets) { toggleFacets(openFacets, false); return; }
      $$('details[open][data-dropdown], details[open][data-search-details]').forEach(function (d) {
        d.removeAttribute('open');
        var s = $('summary', d);
        if (s) s.focus();
      });
    }
    if (e.key === 'Tab' && activeDrawer) {
      var panel = $('.drawer__panel', activeDrawer);
      var items = focusables(panel);
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header dropdowns + search ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    if (d.matches('[data-dropdown], [data-search-details]')) {
      $$('details[open][data-dropdown], details[open][data-search-details]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    }
    if (d.matches('[data-search-details]')) {
      var input = $('input[type="search"]', d);
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
  }, true);

  document.addEventListener('click', function (e) {
    $$('details[open][data-dropdown], details[open][data-search-details]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Announcement bar ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('[data-announcement-slide]', bar);
    if (slides.length < 2 || bar.dataset.autoplay !== 'true' || reduceMotion) return;
    var i = 0, paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity]');
    var input = $('input', wrap);
    var step = parseInt(btn.dataset.quantityStep, 10);
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));
    if (next === parseInt(input.value, 10)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: gallery ---------- */
  function initGallery(gallery) {
    var slidesEl = $('[data-gallery-slides]', gallery);
    if (!slidesEl) return;
    var slides = $$('[data-media-id]', slidesEl);
    var counter = $('[data-gallery-counter]', gallery);
    var current = 0;

    function setActive(index) {
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      $$('[data-gallery-thumb]', gallery).forEach(function (t) {
        if (t.dataset.galleryThumb === slides[index].dataset.mediaId) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
    function goTo(index, smooth) {
      index = (index + slides.length) % slides.length;
      var target = slides[index];
      slidesEl.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActive(index);
      // Pause any playing videos on other slides
      slides.forEach(function (s, i) {
        if (i !== index) $$('video', s).forEach(function (v) { v.pause(); });
      });
    }
    gallery._goToMedia = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) goTo(idx, true);
    };

    slidesEl.addEventListener('scroll', debounce(function () {
      var left = slidesEl.scrollLeft;
      var nearest = 0, best = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - left);
        if (d < best) { best = d; nearest = i; }
      });
      if (nearest !== current) setActive(nearest);
    }, 80), { passive: true });

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) { gallery._goToMedia(thumb.dataset.galleryThumb); return; }
      if (e.target.closest('[data-gallery-prev]')) goTo(current - 1, true);
      if (e.target.closest('[data-gallery-next]')) goTo(current + 1, true);
    });

    var initial = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (initial > 0) goTo(initial, false); else setActive(0);
  }

  /* ---------- Product: variant picker ---------- */
  function priceHTML(v) {
    var s = theme.strings;
    if (v.compare_at_price) {
      return '<div class="price price--on-sale price--large" data-price>' +
        '<span class="visually-hidden">' + escapeHTML(s.salePrice) + '</span>' +
        '<span class="price__current price__current--sale">' + v.price + '</span>' +
        '<span class="visually-hidden">' + escapeHTML(s.regularPrice) + '</span>' +
        '<s class="price__compare">' + v.compare_at_price + '</s></div>';
    }
    return '<div class="price price--large' + (v.available ? '' : ' price--sold-out') + '" data-price>' +
      '<span class="visually-hidden">' + escapeHTML(s.regularPrice) + '</span>' +
      '<span class="price__current">' + v.price + '</span></div>';
  }

  function initProduct(section) {
    var gallery = $('[data-gallery]', section);
    if (gallery) initGallery(gallery);

    var picker = $('[data-variant-picker]', section);
    var json = picker && $('[data-variant-json]', picker);
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }

    picker.addEventListener('change', function () {
      var selected = [];
      $$('select[data-option-index]', picker).forEach(function (s) { selected[+s.dataset.optionIndex] = s.value; });
      $$('input[data-option-index]:checked', picker).forEach(function (i) {
        selected[+i.dataset.optionIndex] = i.value;
        var legendValue = $('[data-selected-value]', i.closest('fieldset'));
        if (legendValue) legendValue.textContent = i.value;
      });

      var variant = variants.find(function (v) {
        return v.options.every(function (o, idx) { return o === selected[idx]; });
      });

      var buttons = $$('[data-add-button]', section);
      var errorEl = $('[data-form-error]', section);
      if (errorEl) errorEl.hidden = true;

      if (!variant) {
        buttons.forEach(function (b) {
          b.disabled = true;
          var t = $('[data-add-button-text]', b);
          if (t) t.textContent = theme.strings.unavailable;
        });
        return;
      }

      $$('form[action*="/cart/add"] input[name="id"]', section).forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        var t = $('[data-add-button-text]', b);
        if (t) t.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      });

      var priceWrap = $('[data-price-container]', section);
      if (priceWrap) priceWrap.innerHTML = priceHTML(variant);

      var skuWrap = $('[data-sku-container]', section);
      if (skuWrap) {
        skuWrap.hidden = !variant.sku;
        var skuEl = $('[data-sku]', skuWrap);
        if (skuEl) skuEl.textContent = variant.sku || '';
      }

      if (variant.media_id && gallery && gallery._goToMedia) gallery._goToMedia(variant.media_id);

      if (section.dataset.updateUrl === 'true' && section.dataset.productUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  $$('[data-product-section]').forEach(initProduct);

  /* ---------- 3D models ---------- */
  if ($('[data-product-models]') && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12' }, { name: 'model-viewer-ui', version: '1.0' }, { name: 'shopify-xr', version: '1.0' }]);
  }

  /* ---------- Cart: rendering helpers ---------- */
  function cartSectionIds() {
    var ids = [];
    var drawer = $('[data-cart-drawer-content]');
    if (drawer) ids.push(drawer.dataset.sectionId);
    var page = $('[data-cart-section]');
    if (page) ids.push(page.dataset.sectionId);
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var activeId = document.activeElement && document.activeElement.id;
    var drawer = $('[data-cart-drawer-content]');
    if (drawer && sections[drawer.dataset.sectionId]) {
      var fresh = $('[data-cart-drawer-content]', parseHTML(sections[drawer.dataset.sectionId]));
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
    var page = $('[data-cart-section]');
    if (page && sections[page.dataset.sectionId]) {
      var freshPage = $('[data-cart-section-content]', parseHTML(sections[page.dataset.sectionId]));
      var target = $('[data-cart-section-content]', page);
      if (freshPage && target) target.innerHTML = freshPage.innerHTML;
    }
    restoreFocus(activeId);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      var visible = el.querySelector('[aria-hidden="true"]');
      if (visible) visible.textContent = Math.min(count, 99);
      var sr = el.querySelector('.visually-hidden');
      if (sr) sr.textContent = String(count);
    });
  }

  function refreshCartCount() {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  /* ---------- Cart: AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    var drawer = $('[data-cart-drawer]');
    if (theme.cartType !== 'drawer' || !drawer || !window.fetch) return; // native submit -> /cart
    e.preventDefault();

    var button = $('[data-add-button]', form);
    var errorEl = $('[data-form-error]', form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
    if (errorEl) errorEl.hidden = true;

    var body = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (errorEl) {
            errorEl.textContent = data.description || data.message || theme.strings.cartError;
            errorEl.hidden = false;
          }
          return;
        }
        renderCartSections(data.sections);
        refreshCartCount();
        openDrawer(drawer, button);
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = theme.strings.cartError; errorEl.hidden = false; }
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  });

  /* ---------- Cart: update quantities / remove ---------- */
  var cartQueue = Promise.resolve();

  function changeLine(line, quantity, form) {
    var items = form && $('[data-cart-items]', form);
    if (items) items.setAttribute('aria-busy', 'true');
    cartQueue = cartQueue.then(function () {
      return fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            var err = form && $('[data-cart-errors]', form);
            if (err) { err.textContent = res.data.description || res.data.message || theme.strings.cartError; err.hidden = false; }
            if (items) items.setAttribute('aria-busy', 'false');
            return;
          }
          renderCartSections(res.data.sections);
          updateCartCount(res.data.item_count);
        })
        .catch(function () {
          var err = form && $('[data-cart-errors]', form);
          if (err) { err.textContent = theme.strings.cartError; err.hidden = false; }
          if (items) items.setAttribute('aria-busy', 'false');
        });
    });
  }

  // Debounce per cart line so quick edits on different lines are all sent.
  var lineTimers = {};
  function debouncedChange(input) {
    var key = (input.form ? input.form.id : '') + ':' + input.dataset.line;
    clearTimeout(lineTimers[key]);
    lineTimers[key] = setTimeout(function () {
      delete lineTimers[key];
      var form = input.closest('[data-cart-form]') || input.form;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(input.dataset.line, 10), qty, form);
    }, 350);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-form] input[data-line], input[data-line][form]');
    if (input && window.fetch) debouncedChange(input);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove || !window.fetch) return;
    e.preventDefault();
    var form = remove.closest('[data-cart-form]');
    changeLine(parseInt(remove.dataset.cartRemove, 10), 0, form);
  });

  var noteInput = debounce(function (textarea) {
    fetch(theme.routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: textarea.value })
    });
  }, 500);
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) noteInput(e.target);
  });

  /* ---------- Collection / search filtering (Section Rendering API) ---------- */
  function toggleFacets(facets, force) {
    var open = typeof force === 'boolean' ? force : !facets.classList.contains('is-open');
    facets.classList.toggle('is-open', open);
    document.body.classList.toggle('has-drawer-open', open);
    $$('[data-facets-toggle][aria-expanded]', facets).forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) {
      var panel = $('[data-facets-panel]', facets);
      var first = panel && focusables(panel)[0];
      if (first) setTimeout(function () { first.focus(); }, 60);
    } else {
      var toggle = $('.facets__toggle', facets);
      if (toggle) toggle.focus();
    }
  }

  function renderFacets(root, url, push) {
    var sectionId = root.dataset.sectionId;
    var wasOpen = !!$('[data-facets].is-open', root);
    var activeId = document.activeElement && document.activeElement.id;
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    root.classList.add('is-loading');
    fetch(fetchUrl.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = $('[data-section-root]', parseHTML(html));
        if (!fresh) { window.location.href = url; return; }
        root.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          var facets = $('[data-facets]', root);
          if (facets) facets.classList.add('is-open');
        } else {
          document.body.classList.remove('has-drawer-open');
        }
        restoreFocus(activeId);
        if (push) window.history.pushState({ facets: true }, '', url);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { root.classList.remove('is-loading'); });
  }

  function facetsUrlFromForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  var submitFacets = debounce(function (form) {
    var root = form.closest('[data-section-root]');
    if (root) renderFacets(root, facetsUrlFromForm(form), true);
  }, 300);

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (form && window.fetch) submitFacets(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    submitFacets(form);
  });
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-facets-toggle]');
    if (toggle) { toggleFacets(toggle.closest('[data-facets]')); return; }
    var link = e.target.closest('[data-facet-link]');
    if (link && window.fetch) {
      var root = link.closest('[data-section-root]');
      if (!root) return;
      e.preventDefault();
      renderFacets(root, link.getAttribute('href'), true);
    }
  });
  window.addEventListener('popstate', function () {
    var root = $('[data-section-root]');
    if (root && $('[data-facets-form]', root)) renderFacets(root, window.location.href, false);
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (!el.dataset.url) return;
    var load = function () {
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = $('[data-recommendations]', parseHTML(html));
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  });

  /* ---------- Localization selectors ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Customer addresses: country / province ---------- */
  function syncProvinces(countrySelect) {
    var provinceSelect = document.getElementById(countrySelect.dataset.provinceTarget);
    if (!provinceSelect) return;
    var option = countrySelect.options[countrySelect.selectedIndex];
    var provinces = [];
    try { provinces = JSON.parse((option && option.getAttribute('data-provinces')) || '[]'); } catch (err) { provinces = []; }
    var wrapper = provinceSelect.closest('[data-province-wrapper]');
    provinceSelect.innerHTML = '';
    if (!provinces.length) { if (wrapper) wrapper.hidden = true; return; }
    if (wrapper) wrapper.hidden = false;
    var wanted = provinceSelect.dataset.default;
    provinces.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[0];
      o.textContent = p[1];
      if (p[0] === wanted || p[1] === wanted) o.selected = true;
      provinceSelect.appendChild(o);
    });
  }
  $$('[data-country-select]').forEach(function (select) {
    var wanted = select.dataset.default;
    if (wanted) {
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.value === wanted || o.textContent === wanted) o.selected = true;
      });
    }
    syncProvinces(select);
    select.addEventListener('change', function () {
      var p = document.getElementById(select.dataset.provinceTarget);
      if (p) p.dataset.default = '';
      syncProvinces(select);
    });
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-confirm]');
    if (form && !window.confirm(form.dataset.confirm)) e.preventDefault();
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer($('[data-cart-drawer]', e.target));
  });
  document.addEventListener('shopify:section:deselect', function () { if (activeDrawer) closeDrawer(null, true); });
})();
